// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Cp8ZO","labelContainer":"styles_labelContainer__3uUjp","label":"styles_label__mGRvA","requiredMark":"styles_requiredMark__7Fyjc"};